export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const GET_DOCUMENTS_SUCCESS = 'GET_DOCUMENTS_SUCCESS';
export const GET_DOCUMENTS_FAILED = 'GET_DOCUMENTS_FAILED';

export const GET_DOCUMENTS_BY_ID = 'GET_DOCUMENTS_BY_ID';
export const GET_DOCUMENTS_BY_ID_SUCCESS = 'GET_DOCUMENTS_BY_ID_SUCCESS';
export const GET_DOCUMENTS_BY_ID_FAILED = 'GET_DOCUMENTS_BY_ID_FAILED';

export const CREATE_DOCUMENT = 'CREATE_DOCUMENT';
export const CREATE_DOCUMENT_SUCCESS = 'CREATE_DOCUMENT_SUCCESS';
export const CREATE_DOCUMENT_FAILED = 'CREATE_DOCUMENT_FAILED';


export const GET_APPROVAL_HISTORY = "GET_APPROVAL_HISTORY";
export const GET_APPROVAL_HISTORY_SUCCESS = "GET_APPROVAL_HISTORY_SUCCESS";
export const GET_APPROVAL_HISTORY_FAILED = "GET_APPROVAL_HISTORY_FAILED";

export const CHANGE_APPROVAL_STATUS = "CHANGE_APPROVAL_STATUS";
export const CHANGE_APPROVAL_STATUS_SUCCESS = "CHANGE_APPROVAL_STATUS_SUCCESS";
export const CHANGE_APPROVAL_STATUS_FAILED = "CHANGE_APPROVAL_STATUS_FAILED";


export const GET_DOCUMENTS_BY_STATUS = "GET_DOCUMENTS_BY_STATUS";
export const GET_DOCUMENTS_BY_STATUS_SUCCESS = "GET_DOCUMENTS_BY_STATUS_SUCCESS";
export const GET_DOCUMENTS_BY_STATUS_FAILED = "GET_DOCUMENTS_BY_STATUS_FAILED";


export const EDIT_DOCUMENT = 'EDIT_DOCUMENT';
export const EDIT_DOCUMENT_SUCCESS = 'EDIT_DOCUMENT_SUCCESS';
export const EDIT_DOCUMENT_FAILED = 'EDIT_DOCUMENT_FAILED';

export const DISCARD_DOCUMENT = 'DISCARD_DOCUMENT';
export const DISCARD_DOCUMENT_SUCCESS = 'DISCARD_DOCUMENT_SUCCESS';
export const DISCARD_DOCUMENT_FAILED = 'DISCARD_DOCUMENT_FAILED';

export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS';
export const DELETE_DOCUMENT_FAILED = 'DELETE_DOCUMENT_FAILED';

export const PREVIEW_DOCUMENT = 'PREVIEW_DOCUMENT';
export const PREVIEW_DOCUMENT_SUCCESS = 'PREVIEW_DOCUMENT_SUCCESS';
export const PREVIEW_DOCUMENT_FAILED = 'PREVIEW_DOCUMENT_FAILED';

export const GET_DOCUMENT_ITEMS = 'GET_DOCUMENT_ITEMS';
export const GET_DOCUMENT_ITEMS_SUCCESS = 'GET_DOCUMENT_ITEMS_SUCCESS';
export const GET_DOCUMENT_ITEMS_FAILED = 'GET_DOCUMENT_ITEMS_FAILED'; 

export const SHORT_CLOSE_TRANSACTION = 'SHORT_CLOSE_TRANSACTION';
export const SHORT_CLOSE_TRANSACTION_SUCCESS = 'SHORT_CLOSE_TRANSACTION_SUCCESS';
export const SHORT_CLOSE_TRANSACTION_FAILED = 'SHORT_CLOSE_TRANSACTION_FAILED'; 

export const GET_SALES_DOCUMENTS_ITEMS = 'GET_SALES_DOCUMENTS_ITEMS';
export const GET_SALES_DOCUMENTS_ITEMS_SUCCESS = 'GET_SALES_DOCUMENTS_ITEMS_SUCCESS';
export const GET_SALES_DOCUMENTS_ITEMS_FAILED = 'GET_SALES_DOCUMENTS_ITEMS_FAILED'; 

export const GET_SERVICE_CHALLAN_ITEMS = 'GET_SERVICE_CHALLAN_ITEMS';
export const GET_SERVICE_CHALLAN_ITEMS_SUCCESS = 'GET_SERVICE_CHALLAN_ITEMS_SUCCESS';
export const GET_SERVICE_CHALLAN_ITEMS_FAILED = 'GET_SERVICE_CHALLAN_ITEMS_FAILED'; 

export const GET_TABLE_DOCUMENTS = 'GET_TABLE_DOCUMENTS';
export const GET_TABLE_DOCUMENTS_SUCCESS = 'GET_TABLE_DOCUMENTS_SUCCESS';
export const GET_TABLE_DOCUMENTS_FAILED = 'GET_TABLE_DOCUMENTS_FAILED';

export const CREATE_EINVOICE = 'CREATE_EINVOICE';
export const CREATE_EINVOICE_SUCCESS = 'CREATE_EINVOICE_SUCCESS';
export const CREATE_EINVOICE_FAILED = 'CREATE_EINVOICE_FAILED';

export const CREATE_EWAYBILL = 'CREATE_EWAYBILL';
export const CREATE_EWAYBILL_SUCCESS = 'CREATE_EWAYBILL_SUCCESS';
export const CREATE_EWAYBILL_FAILED = 'CREATE_EWAYBILL_FAILED';

export const FETCH_CURRENT_DOC = 'FETCH_CURRENT_DOC';
export const FETCH_CURRENT_DOC_SUCCESS = 'FETCH_CURRENT_DOC_SUCCESS';
export const FETCH_CURRENT_DOC_FAILED = 'FETCH_CURRENT_DOC_FAILED';

export const EMAIL_DOCUMENT = 'EMAIL_DOCUMENT';
export const EMAIL_DOCUMENT_SUCCESS = 'EMAIL_DOCUMENT_SUCCESS';
export const EMAIL_DOCUMENT_FAILED = 'EMAIL_DOCUMENT_FAILED';

export const CANCEL_EINVOICE = 'CANCEL_EINVOICE';
export const CANCEL_EINVOICE_SUCCESS = 'CANCEL_EINVOICE_SUCCESS';
export const CANCEL_EINVOICE_FAILED = 'CANCEL_EINVOICE_FAILED';

export const GET_CHALLAN_ITEMS = 'GET_CHALLAN_ITEMS';
export const GET_CHALLAN_ITEMS_SUCCESS = 'GET_CHALLAN_ITEMS_SUCCESS';
export const GET_CHALLAN_ITEMS_FAILED = 'GET_CHALLAN_ITEMS_FAILED'; 

export const CREATE_EWAYBILL_FROM_EINVOICE = 'CREATE_EWAYBILL_FROM_EINVOICE';
export const CREATE_EWAYBILL_FROM_EINVOICE_SUCCESS = 'CREATE_EWAYBILL_FROM_EINVOICE_SUCCESS';
export const CREATE_EWAYBILL_FROM_EINVOICE_FAILED = 'CREATE_EWAYBILL_FROM_EINVOICE_FAILED';

export const CANCEL_EWAYBILL = 'CANCEL_EWAYBILL';
export const CANCEL_EWAYBILL_SUCCESS = 'CANCEL_EWAYBILL_SUCCESS';
export const CANCEL_EWAYBILL_FAILED = 'CANCEL_EWAYBILL_FAILED';

export const SAVE_RFQ_QUOTATION = 'SAVE_RFQ_QUOTATION';
export const SAVE_RFQ_QUOTATION_SUCCESS = 'SAVE_RFQ_QUOTATION_SUCCESS';
export const SAVE_RFQ_QUOTATION_FAILED = 'SAVE_RFQ_QUOTATION_FAILED';